import {PostBeneficiaryParams} from 'domain/usecases';
import {makePostBeneficiary} from 'main/factories/usecases';

export const postBeneficiary = async (params: PostBeneficiaryParams) =>
	makePostBeneficiary().post(params);
